export const $on = (eventName, callback) => {
    uni.$on(eventName, callback)
    return () => {
        eventName && uni.$off(eventName, callback)
    }
}

export const $once = (eventName, callback) => {
    uni.$once(eventName, callback)
}

export const $emit = (eventName, value) => {
    uni.$emit(eventName, value)
}
